var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import { statusColors } from 'syf-component-library/defaultTheme';
import { CAPAutopayStatuses } from '../../../../const';
import { getButtonAnalytics } from '../../../../helpers/getAnalytics';
import { MAPFlowTypes } from 'make-a-payment';
import { RenderIf } from 'syf-component-library/ui/atoms';
import useTranslation from '../../../../hooks/use-translation';
import { colors } from '../../../../theme';
import { StyledTitle } from '../../../subcomponents';
import { StyledLink, StyledMessageBox } from './subcomponents';
var PlanMessageBox = function (_a) {
    var navigateTo = _a.navigateTo, autoPayStatus = _a.autoPayStatus, currentRoute = _a.currentRoute;
    var _b = useState(true), showPlanInfoMessage = _b[0], setShowPlanInfoMessage = _b[1];
    var i18n = useTranslation();
    var _c = getButtonAnalytics(currentRoute), dataAnalytics = _c.dataAnalytics, dataObject = _c.dataObject, dataType = _c.dataType;
    var messageBoxRef = useRef(null);
    var messageBoxAutopayEnrollmentHeading = '';
    var messageBoxAutopayEnrollmentMessage = '';
    var messageBoxIcon = '';
    var messageBoxLinkColor = '';
    switch (autoPayStatus) {
        case CAPAutopayStatuses.ERROR:
            messageBoxAutopayEnrollmentHeading = i18n('plan.messageBoxCancelAutopayFailedHeading');
            messageBoxAutopayEnrollmentMessage = i18n('plan.messageBoxErrorText');
            messageBoxLinkColor = statusColors.error.icon;
            messageBoxIcon = 'circle-exclamation';
            break;
        case CAPAutopayStatuses.WARNING:
            messageBoxAutopayEnrollmentHeading = i18n('plan.messageBoxAutopayReEnrollHeading');
            messageBoxAutopayEnrollmentMessage = i18n('plan.messageBoxText');
            messageBoxLinkColor = statusColors.warning.icon;
            messageBoxIcon = 'circle-exclamation';
            break;
        case CAPAutopayStatuses.INFO:
            messageBoxAutopayEnrollmentHeading = i18n('plan.messageBoxAutopayHeading');
            messageBoxAutopayEnrollmentMessage = i18n('plan.messageBoxText');
            messageBoxLinkColor = colors.cyanBlue;
            messageBoxIcon = 'info-circle';
            break;
        default:
            break;
    }
    useEffect(function () {
        var _a;
        var button = (_a = messageBoxRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('button');
        if (button) {
            button.setAttribute('data-type', 'dch cap autopay');
            button.setAttribute('data-reason', 'x button');
            button.setAttribute('data-object', 'button');
            button.setAttribute('data-analytics', 'clicktrackingevent');
        }
    }, [autoPayStatus]);
    return (showPlanInfoMessage && (_jsx(Inset, { children: _jsxs(StyledMessageBox, __assign({ ref: messageBoxRef, closeHandler: function () { return setShowPlanInfoMessage(false); }, icon: _jsx(FontAwesomeIcon, { width: 48, icon: ['fas', messageBoxIcon], size: "1x" }), type: autoPayStatus }, { children: [_jsx(StyledTitle, __assign({ weight: "bold", size: "root" }, { children: messageBoxAutopayEnrollmentHeading })), messageBoxAutopayEnrollmentMessage, _jsx(Stack, {}), _jsx(RenderIf, __assign({ condition: autoPayStatus !== CAPAutopayStatuses.ERROR }, { children: _jsx(StyledLink, __assign({ "data-object": dataObject, "data-type": "".concat(dataType, " banner"), "data-reason": i18n('plan.messageBoxAutopayEnrollLink'), "data-analytics": dataAnalytics, onClick: function () { return navigateTo === null || navigateTo === void 0 ? void 0 : navigateTo('payment', MAPFlowTypes.AUTOPAY_FLOW); }, color: messageBoxLinkColor }, { children: i18n('plan.messageBoxAutopayEnrollLink') })) }))] })) })));
};
export default PlanMessageBox;
//# sourceMappingURL=index.js.map